module.exports = __webpack_public_path__ + "static/media/pa.dbe7b050.svg";